import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPupils, getStaffEntries } from "../firebase/functions";
import { makeSingleArray, objectToArray } from "../utils/helperFunctions";

const initialState = {
  staff: {
    data: {
      name: "",
      className: "",
      id: "",
    },
  },
  pupils: {
    data: [],
  },
};

export const pupilsThunk = createAsyncThunk(
  "staff/pupils",
  async (args, { getState, rejectWithValue }) => {
    try {
      const className = getState().staff.staff.data.className;
      const pupilsEntries = await getPupils(className);

      return pupilsEntries;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const staffDataSlice = createSlice({
  name: "staffData",
  initialState,
  reducers: {
    getStafffLoginCred: (state, action) => {
      let loginCred = window.localStorage.getItem("loginCred");
      if (loginCred) {
        loginCred = JSON.parse(loginCred);
        state.staff.data = { ...state.staff.data, ...loginCred };
      }
    },
    loginStaff: (state, action) => {
      const { name, className, id } = action.payload;
      state.staff.data.name = name;
      state.staff.data.className = className;
      state.staff.data.id = id;

      const staffData = JSON.stringify({
        name,
        id,
        className,
      });
      window.localStorage.setItem("loginCred", staffData);
    },
  },
  extraReducers: {
    [pupilsThunk.fulfilled]: (state, action) => {
      const pupilsData = makeSingleArray(objectToArray(action.payload));
      state.pupils.data = [...pupilsData];
    },
    [pupilsThunk.rejected]: (state, action) => {
      state.pupils.data = [];
    },
  },
});

const staffDataReducer = staffDataSlice.reducer;

export const { loginStaff, getStafffLoginCred } = staffDataSlice.actions;
export default staffDataReducer;
